const STORAGE_HTML_KEY = 'collectionGridHtml';
const STORAGE_PAGE_KEY = 'collectionGridPage';
const STORAGE_URL_KEY = 'collectionGridUrl';
const GRID_CONTAINER_ID = 'ProductGridContainer';

function getPageFromUrl(urlString) {
  const url = new URL(urlString, window.location.origin);
  const page = parseInt(url.searchParams.get('page') || '1', 10);
  return Number.isNaN(page) || page < 1 ? 1 : page;
}

function syncCollectionPageToUrl(page) {
  const url = new URL(window.location.href);
  if (page > 1) {
    url.searchParams.set('page', String(page));
  } else {
    url.searchParams.delete('page');
  }
  history.replaceState({}, '', url.toString());
}

function clearCollectionGridCache() {
  sessionStorage.removeItem(STORAGE_HTML_KEY);
  sessionStorage.removeItem(STORAGE_PAGE_KEY);
  sessionStorage.removeItem(STORAGE_URL_KEY);
}

function saveCollectionGridState() {
  const container = document.getElementById(GRID_CONTAINER_ID);
  if (!container) return;

  sessionStorage.setItem(STORAGE_HTML_KEY, container.innerHTML);
  sessionStorage.setItem(STORAGE_PAGE_KEY, String(getPageFromUrl(window.location.href)));
  sessionStorage.setItem(STORAGE_URL_KEY, window.location.href);
}

function reinitializeCollectionGrid() {
  console.log('reinitializeCollectionGrid');
  const container = document.getElementById(GRID_CONTAINER_ID);
  if (!container) return;

  const gridList = container.querySelector('grid-list');
  if (gridList?.reload) gridList.reload();

  document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
}

let collectionGridRestored = false;

function restoreCollectionGridIfCached() {
  if (collectionGridRestored) return;

  const container = document.getElementById(GRID_CONTAINER_ID);
  if (!container) return;

  const storedUrl = sessionStorage.getItem(STORAGE_URL_KEY);
  const storedHtml = sessionStorage.getItem(STORAGE_HTML_KEY);

  if (!storedUrl || !storedHtml) {
    clearCollectionGridCache();
    return;
  }

  if (storedUrl !== window.location.href) {
    clearCollectionGridCache();
    return;
  }

  container.innerHTML = storedHtml;
  collectionGridRestored = true;
  clearCollectionGridCache();
  reinitializeCollectionGrid();

  console.log('buildCollectionGrid');
}

function isBackNavigation() {
  const nav = performance.getEntriesByType('navigation')[0];
  return nav?.type === 'back_forward';
}

function bindProductCardClicks() {
  const container = document.getElementById(GRID_CONTAINER_ID);
  if (!container) return;

  container.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link || !container.contains(link)) return;
    saveCollectionGridState();
  });
}

function bindCollectionGridEvents() {
  document.addEventListener('collection:rerendered', clearCollectionGridCache);

  if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub?.PUB_SUB_EVENTS?.facetUpdate) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, clearCollectionGridCache);
  }
}

document.addEventListener('collection-grid:loaded-more', (event) => {
  let page = event.detail?.page;

  if (!Number.isFinite(page) || page < 1) {
    page = event.detail?.fetchUrl ? getPageFromUrl(event.detail.fetchUrl) : null;
  }

  if (Number.isFinite(page) && page > 1) {
    syncCollectionPageToUrl(page);
  }
});

function initCollectionGridCustom() {
  if (!document.getElementById(GRID_CONTAINER_ID)) return;

  const storedUrl = sessionStorage.getItem(STORAGE_URL_KEY);
  if (storedUrl && storedUrl !== window.location.href) {
    clearCollectionGridCache();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted || isBackNavigation()) {
      restoreCollectionGridIfCached();
    }
  });

  if (isBackNavigation()) {
    restoreCollectionGridIfCached();
  }

  bindProductCardClicks();
  bindCollectionGridEvents();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionGridCustom);
} else {
  initCollectionGridCustom();
}
